import { filterPage } from "components/common/Filters/FiltersHelper";
import Sections from "../Sections/List";
import PlanProgressList from "./PlanProgressList";

export const tabDetails = (selectedPlanDetail: any, planType: string, isCorp = false) => {
  const tabInfo = [
    {
      label: "Action Plan",
      content: Hoc(Sections, selectedPlanDetail, planType),
      filtersToClear: [filterPage.planProgressFromLibraryDisplay, filterPage.libraryPlanDetailsDisplay]
    }
  ];

  if (isCorp)
    tabInfo?.push({
      label: "Plan Progress",
      content: PlanProgressList,
      filtersToClear: []
    });

  return tabInfo;
};

function Hoc(WrappedComponent: any, data: any, planType: string) {
  return function (props: any) {
    return <WrappedComponent {...props} selectedPlanDetail={data} planType={planType} />;
  };
}
